const initialState = {
  loading: false,
  fetched: false,
  productIds: [],
};

export default function productsListReducer(state = initialState, action) {
  switch (action.type) {
    case "PRODUCTS_FETCH_REQUESTED":
      return {
        ...state,
        loading: true,
      };
    case "PRODUCTS_FETCHED":
      return {
        ...state,
        loading: false,
        fetched: true,
        productIds: action.result || [],
      };
    default:
      return state;
  }
}
